import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { DateTime, Duration } from "luxon";

import { mdiLoading } from "@mdi/js";
import Icon from "@mdi/react";
import { formatDate } from "../../../utils/dateTime";
import { IOrderShipment } from "../../../types";

interface Props {
    className?: string;
    productId?: string;
    align?: "start" | "center" | "end";
    justify?: "start" | "center" | "end";
    countdownTextSize?: string;
}

export default function OrderInTheNext({ className = "uppercase p-5 bg-white text-lg", productId, align = "center", justify = "start", countdownTextSize = "" }: Props) {

    const [estDispatchDate, setEstDispatchDate] = React.useState<DateTime | null>(null);

    const [countdown, setCountdown] = React.useState<string[] | null | "loading">("loading");
    const allShipments = useSelector((state: RootState) => state.order.order?.shipments);

    React.useEffect(() => {

        const shipments = (allShipments || []).filter(s => s.type != "ELECTRONIC");

        if (shipments && (shipments?.length || 0) > 0) {
            const estDispatchDateTime = loadCartInfo(shipments);

            let interval: any = null;

            const countdown = () => {
                const now = DateTime.now();
                const remainingTime = estDispatchDateTime.diff(now);
                const milliseconds = remainingTime.as("milliseconds");
                if (milliseconds <= 0) {
                    setCountdown(null);
                    clearInterval(interval);
                } else {
                    setCountdown(formatCountdown(remainingTime));
                }
            };

            countdown();
            interval = setInterval(countdown, 1000);

            return () => {
                clearInterval(interval);
            };
        }
    }, [productId, allShipments]);

    const loadCartInfo = (shipments: IOrderShipment[]): DateTime => {

        const soonest = shipments.reduce((prev, current) => {
            const prevDate = DateTime.fromISO(prev.estDispatchDate as string);
            const currentDate = DateTime.fromISO(current.estDispatchDate as string);
            return prevDate < currentDate ? prev : current;
        });

        const estDispatchDateTime = DateTime.fromISO(soonest.estDispatchDate as string);
        setEstDispatchDate(estDispatchDateTime);

        return estDispatchDateTime;
    };

    const formatCountdown = (duration: Duration) => {
        let hours: any = Math.floor(duration.as("hours"));
        const minutes = Math.floor(duration.as("minutes") % 60);
        const seconds = Math.floor(duration.as("seconds") % 60);

        return [
            hours < 10 ? "0" + hours : hours,
            minutes < 10 ? "0" + minutes : minutes,
            seconds < 10 ? "0" + seconds : seconds
        ];
    };

    const dipsatchedOn = useMemo(() => {
        if (estDispatchDate) {
            // if tomorrow

            const diff = estDispatchDate.diff(DateTime.now(), "days").days;

            if (estDispatchDate.hasSame(DateTime.now(), "day")) {
                return "today";
            }
            if (estDispatchDate.hasSame(DateTime.now().plus({ days: 1 }), "day")) {
                return "tomorrow";
            }
            if (diff && diff < 4) {
                return "in " + Math.ceil(diff) + " days";
            }
            return "on " + formatDate(estDispatchDate);
        }
        return "";
    }, [estDispatchDate]);

    if (!allShipments || (allShipments?.length || 0) < 1) {
        return <></>;
    }

    return (
        <div className={`text-${align} flex justify-${justify}`}>
            <div className={`${className}`}>
                <div>order in the next</div>
                <div className={`flex justify-${align} items-center py-2`}>
                    <div
                        className={`flex justify-center items-center text-center p-1 rounded bg-primary font-bold min-w-[105px] ${countdownTextSize} ${countdown == "loading" ? "opacity-50" : ""
                            }`}
                    >
                        {countdown == null ? (
                            <>
                                <div className="">EXPIRED</div>
                            </>
                        ) : (
                            <>
                                <span className="flex justify-center items-center w-[35px]">
                                    {countdown != "loading" ? (
                                        countdown[0]
                                    ) : (
                                        <Icon spin={0.8} path={mdiLoading} size={0.6} />
                                    )}
                                </span>
                                <span className="inline-block">:</span>
                                <span className="flex justify-center items-center w-[35px]">
                                    {countdown != "loading" ? (
                                        countdown[1]
                                    ) : (
                                        <Icon spin={0.8} path={mdiLoading} size={0.6} />
                                    )}
                                </span>
                                <span className="inline-block">:</span>
                                <span className="flex justify-center items-center w-[35px]">
                                    {countdown != "loading" ? (
                                        countdown[2]
                                    ) : (
                                        <Icon spin={0.8} path={mdiLoading} size={0.6} />
                                    )}
                                </span>
                            </>
                        )}
                    </div>
                </div>
                <div>for dispatch {dipsatchedOn}</div>
            </div>
        </div>
    );
}
